export function buildAuthModalHtml(): string {
  return `
      <div class="auth-modal-header">
        <button id="authModalBack" class="auth-modal-back hidden">&larr;</button>
        <h3 id="authModalTitle">Entrar</h3>
        <button id="authModalClose" class="auth-modal-close">&times;</button>
      </div>
      <div id="authModalBody" class="auth-modal-body">
        <div id="authError" class="auth-error hidden"></div>
        <div id="authNameGroup" class="auth-field-group hidden">
          <label class="auth-label">Nome</label>
          <input type="text" id="authNameInput" class="auth-input" placeholder="Seu nome">
        </div>
        <div class="auth-field-group">
          <label class="auth-label">Email</label>
          <input type="email" id="authEmailInput" class="auth-input" placeholder="email@exemplo.com">
        </div>
        <div id="authPasswordGroup" class="auth-field-group">
          <label class="auth-label">Senha</label>
          <input type="password" id="authPasswordInput" class="auth-input" placeholder="Mínimo 6 caracteres">
          <span id="authForgotLink" class="auth-forgot-link hidden">Esqueci minha senha</span>
        </div>
        <div id="authNewPasswordGroup" class="auth-field-group hidden">
          <label class="auth-label">Nova senha</label>
          <input type="password" id="authNewPasswordInput" class="auth-input" placeholder="Mínimo 6 caracteres">
        </div>
        <div id="authResetInfo" class="auth-reset-info hidden">
          Enviamos um link de redefinição para seu email. Verifique sua caixa de entrada.
        </div>
      </div>
      <div id="authModalFooter" class="auth-modal-footer">
        <button id="authSubmitBtn" class="btn btn-primary auth-submit-btn">Entrar</button>
        <button id="authToggleBtn" class="btn btn-sm btn-secondary auth-toggle-btn">Criar conta</button>
      </div>
    `;
}